import ApiService from "../../api/api.service";
import { GET_INSURANCE_FORM_DETAIL, SAVE_INSURANCE_FORM_DETAIL, EDIT_INSURANCE_FORM, 
UPDATE_INSURANCE_FORM, GET_LIFE_FORM, GET_HEALTH_FORM, GET_PROPERTY_FORM, GET_GROUP_FORM, GET_VEHICLE_FORM, GET_TRAVEL_FORM, GET_ACCIDENTAL_FORM, GET_POLICY_NAME_DATA} from "../actions.type";

const getDefaultInsuranceState = () => {
	return {
		insuranceFormDetail: {},
		saveInsuranceFormDetail: {},
		editInsuranceForm: {},
		updateInsuranceForm: {},
		lifeForm: {},
		healthForm: {},
		groupForm: {},
		accidentalForm: {},
		vehicleForm: {},
		propertyForm: {},
		travelForm: {},
		policyName: {},
		bankPostData: {},
	}
};

const state = getDefaultInsuranceState();

const getters = {

	getInsuranceFormDetail(state) {
		return state.insuranceFormDetail;
	},
	getSaveInsuranceFormDetail(state) {
		return state.saveInsuranceFormDetail;
	},
	getEditInsuranceForm(state) {
		return state.editInsuranceForm;
	},
	getUpdateInsuranceForm(state) {
		return state.updateInsuranceForm;
	},
	getHealthForm(state) {
		return state.healthForm;
	},
	getLifeForm(state) {
		return state.lifeForm;
	},
	getGroupForm(state) {
		return state.groupForm;
	},
	getAccidentalForm(state) {
		return state.accidentalForm;
	},
	getVehicleForm(state) {
		return state.vehicleForm;
	},
	getPropertyForm(state) {
		return state.propertyForm;
	},
	getTravelForm(state) {
		return state.travelForm;
	},
	getPolicyNameData(state) {
		return state.policyName;
	},
	
};

const mutations = {

	setInsuranceFormDetail (state, data) {
		state.insuranceFormDetail = data
	},
	setSaveInsuranceFormDetail (state, data) {
		state.saveInsuranceFormDetail = data
	},
	setEditInsuranceForm(state, data) {
		state.editInsuranceForm = data
	},
	setUpdateInsuranceForm(state, data) {
		state.updateInsuranceForm = data
	},
	setHealthForm(state, data) {
		state.healthForm = data
	},
	setLifeForm (state, data) {
		state.lifeForm = data
	},
	setGroupForm (state, data) {
		state.groupForm = data
	},
	setAccidentalForm (state, data) {
		state.accidentalForm = data
	},
	setVehicleForm (state, data) {
		state.vehicleForm = data
	},
	setPropertyForm (state, data) {
		state.propertyForm = data
	},
	setTravelForm (state, data) {
		state.travelForm = data
	},
	setPolicyNameData (state, data) {
		state.policyName = data
	},
};


const actions = {

	[GET_INSURANCE_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setInsuranceFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_INSURANCE_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveInsuranceFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[EDIT_INSURANCE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditInsuranceForm',data);
				data.data.master_data.forEach(element => {

					if (element.AccountType) {
						context.commit('setHealthForm',element.AccountType);
					}
					if (element.SchemeAccountType) {
						context.commit('setHealthForm',element.SchemeAccountType);
					}

				});
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_INSURANCE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateInsuranceForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_TRAVEL_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setTravelForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_LIFE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setLifeForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_HEALTH_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setHealthForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PROPERTY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPropertyForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_VEHICLE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setVehicleForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_GROUP_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setGroupForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_ACCIDENTAL_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setAccidentalForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_POLICY_NAME_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPolicyNameData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}